import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetActiveUserSetLeads } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

// leads someone else made the current user active on
export const useActiveUserSetLeads = () => {
    const queryKey = queryKeys.getActiveUserSetLeads();
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getActiveUserSetLeads,
        schema: schemaLoanRequestResolver_GetActiveUserSetLeads,
        searchParams: { position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
